import React from 'react';
import RedInfo from '../assets/images/RedInfo.svg';

export default () => {
  return <img src={RedInfo} alt="" />;
};
